import { Order } from "@/interfaces";
import { roundCurrency } from "@/utils";

export class OrderHelper {
  static getTotal = (order?: Order) =>
    roundCurrency(
      (order?.total || 0) -
        (order?.coopUsed || 0) -
        (order?.couponUsed || 0) -
        (order?.discount || 0) +
        (order?.shippingFee || 0)
    );
}
